module.exports = __webpack_public_path__ + "static/media/Avatar9.1710d579.png";